import { connect } from 'react-redux';
import Footer from '../components/FooterComponent';

const mapStateToProps = () => ({
    // locked: state.getIn(['aovivoBar', 'AovivoBar', 'locked']),
    // a1LogoUrl: state.app.a1LogoUrl,
    // a1LogoAlt: state.app.a1LogoAlt,
});

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
export default connect(mapStateToProps, {})(Footer);
